import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-meter-header-item',
  templateUrl: './meter-header-item.component.html',
  styleUrls: ['./meter-header-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeterHeaderItemComponent {
  @Input() title: string = '';
  @Input() contentText: string = '';
  @Input() contentIconSvg?: string;
  @Input() contentIconPng?: string;
  @Input() meterTypeName?: string;
  @Input() hasTooltip?: boolean;
}
